exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".history-modal .modal-dialog{width:583px;max-height:75vh;overflow-y:scroll}.history-modal .modal-dialog .head{width:100%;padding:20px 17px 19px;background:#4571cc}.history-modal .modal-dialog .head h2{font-size:18px;line-height:1;color:#fff;text-align:left;text-transform:none}.history-modal .modal-dialog .head .fancybox-close{width:18px;height:18px;position:absolute;top:17px;right:20px;cursor:pointer;display:block;z-index:8040;background:transparent!important}.history-modal .modal-dialog .head .fancybox-close:before{content:\"\";position:absolute;width:25px;height:2px;background:#fff;transform:rotate(-45deg);left:-4px;bottom:8px}.history-modal .modal-dialog .head .fancybox-close:after{content:\"\";position:absolute;width:25px;height:2px;background:#fff;transform:rotate(45deg);left:-4px;bottom:8px}@media (max-width:768px){.history-modal .modal-dialog{position:absolute;width:100vw;height:100vh;max-height:100vh;margin:0}.history-modal .modal-dialog .modal-content{border:none;box-shadow:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/view/history/history.scss
// module id = 831
// module chunks = 0